import React from 'react';

import './style.css';

const ButtPlugIcon = () => (
  <svg className="ButtPlugIcon" viewBox="0 0 84.73 205.41">
    <g id="Ebene_2">
      <g id="Plug">
        <path d="M1.59,49.27A41.33,41.33,0,0,0,42.76,83.72L48.91,120c-8.74,4.81-13.8,16-11.78,28,24.42,79.11,47.26,73.69,44.95-7.62-2-11.92-10.49-20.85-20.33-22.52L55.61,81.54a41.35,41.35,0,1,0-54-32.27ZM72.87,37.2A30.94,30.94,0,1,1,37.2,11.86,30.94,30.94,0,0,1,72.87,37.2Z" fill="#c6bddc"/>
        <path d="M55.15,117.82c12.4-2.1,24.47,8,26.93,22.52A115.38,115.38,0,0,0,37.13,148C34.67,133.42,42.74,119.92,55.15,117.82Z" fill="#b3a7d0"/>
        <path d="M1.59,49.27A41.33,41.33,0,0,0,42.76,83.72L48.91,120c-8.74,4.81-13.8,16-11.78,28,24.42,79.11,47.26,73.69,44.95-7.62-2-11.92-10.49-20.85-20.33-22.52L55.61,81.54a41.35,41.35,0,1,0-54-32.27ZM72.87,37.2A30.94,30.94,0,1,1,37.2,11.86,30.94,30.94,0,0,1,72.87,37.2Z" fill="none" stroke="#8e82a3" strokeWidth="2"/>
      </g>
    </g>
  </svg>
);

export default ButtPlugIcon;


// WEBPACK FOOTER //
// ./src/game/components/toys/ButtPlugIcon/index.js